import * as React from 'react';
import classnames from 'classnames';
import { InView } from 'react-intersection-observer';
import { pushImageGalleryItemClickEvent } from '../../../Analytics/events/ImageGalleryEvents.js';
import { useProductImageGallerySlots } from '../../slots/context.js';
import { useImageSlider } from '../hooks/use-image-slider.js';
import { HorizontalImageSlider } from '../HorizontalImageSlider/HorizontalImageSlider.js';
import { ProductImage } from '../ProductImage/ProductImage.js';
import { ZoomModal } from '../ZoomModal/ZoomModal.js';

const ProductImageGalleryMobile = ({ images , imageParams , sku , handleImageInteraction , zoomModalOpenIndex , hasTopSpacing =false ,  })=>{
    const { Slots  } = useProductImageGallerySlots();
    const { setSlide , activeIndex , handleInView  } = useImageSlider(images.length, {
        elementIdentifierString: 'mobile__image-scroll-item'
    });
    const activeImage1 = images[activeIndex];
    const handleThumbnailClick = React.useCallback((thumbnail)=>{
        const activeImage = images.findIndex((image)=>image.label === thumbnail.label
        );
        setSlide(activeImage);
        sku && pushImageGalleryItemClickEvent(activeImage, sku, thumbnail);
    }, [
        images,
        setSlide
    ]);
    if (!Boolean(images.length)) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("section", {
        className: classnames('product-image-gallery-mobile', {
            'product-image-gallery-mobile--has-top-spacing': hasTopSpacing
        })
    }, Slots.TopLeft && /*#__PURE__*/ React.createElement(Slots.TopLeft, {
        className: "product-image-gallery-mobile__top-left"
    }), Slots.TopRight && /*#__PURE__*/ React.createElement(Slots.TopRight, {
        className: "product-image-gallery-mobile__top-right"
    }), /*#__PURE__*/ React.createElement("div", {
        className: "product-image-gallery-mobile__images"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "product-image-gallery-mobile__wrapper"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "product-image-gallery-mobile__image-scroller"
    }, images.map((image, index)=>/*#__PURE__*/ React.createElement(InView, {
            key: image.label,
            threshold: 0.8,
            onChange: (inView)=>handleInView(inView, index)
        }, ({ ref  })=>/*#__PURE__*/ React.createElement("div", {
                ref: ref,
                id: `mobile__image-scroll-item-${index}`,
                className: `product-image-gallery-mobile__image-scroller-item`
            }, /*#__PURE__*/ React.createElement(ProductImage, {
                altText: image.altText,
                imageUrl: image.url,
                imageParams: imageParams,
                onClick: ()=>handleImageInteraction(index)
            }))
        )
    ))), images.length > 1 && activeImage1 && /*#__PURE__*/ React.createElement("div", {
        className: "product-image-gallery-mobile__thumbnails",
        "data-t": "image-gallery-mobile__thumbnails"
    }, /*#__PURE__*/ React.createElement(HorizontalImageSlider, {
        images: images,
        onClick: handleThumbnailClick,
        activeImage: activeImage1
    }))), /*#__PURE__*/ React.createElement(ZoomModal, {
        isOpen: zoomModalOpenIndex !== null,
        openingIndex: activeIndex,
        onClose: ()=>handleImageInteraction(null)
        ,
        images: images
    }));
};

export { ProductImageGalleryMobile, ProductImageGalleryMobile as default };
//# sourceMappingURL=ProductImageGalleryMobile.js.map
